import {
  Arrow,
  FieldName,
  FieldValue,
  OverallStatsWrapper,
  TitleRow,
  TitleText,
} from './DTRbiHockeyChallengeWidget.styles';
import React from 'react';
import { IconArrow } from '../../../../common/SVGIcons';

export const OverallStats = ({ correctPicks, daysPlayed, pickAccuracy, currentRank, previousRank }) => {
  const ARROW_ICON = (
    <Arrow>
      <IconArrow />
    </Arrow>
  );

  return (
    <OverallStatsWrapper>
      <TitleText>Overall Stats</TitleText>
      <TitleRow>
        <FieldName>Correct Picks</FieldName>
        {ARROW_ICON}
        <FieldValue>{correctPicks}</FieldValue>
      </TitleRow>
      <TitleRow>
        <FieldName>Days Played</FieldName>
        {ARROW_ICON}
        <FieldValue>{daysPlayed} days</FieldValue>
      </TitleRow>
      <TitleRow>
        <FieldName>Pick Accuracy</FieldName>
        {ARROW_ICON}
        <FieldValue>{pickAccuracy} %</FieldValue>
      </TitleRow>
      <TitleRow>
        <FieldName>Previous Rank</FieldName>
        {ARROW_ICON}
        <FieldValue>{previousRank}</FieldValue>
      </TitleRow>
      <TitleRow>
        <FieldName>Current Rank</FieldName>
        {ARROW_ICON}
        <FieldValue>{currentRank}</FieldValue>
      </TitleRow>
    </OverallStatsWrapper>
  );
};
